import React from "react";

/**
 * HeroImage — Landing page hero illustration.
 * Shows a person reviewing their retirement timeline on a tablet.
 */
export const HeroImage: React.FC = () => {
  return (
    <div className="hero-image" id="hero-image">
      <img
        src="/images/hero/hero-main.jpg"
        alt="Retirement planning dashboard showing a timeline projection"
        className="hero-image-illustration"
        width={500}
        height={400}
      />
    </div>
  );
};

export default HeroImage;
